import PensionsInfoAftalerView from './PensionsInfoAftalerView.js';

export default PensionsInfoAftalerView;
